import React from 'react';

function PageLabel({ text, icon, className }) {
    return (
        <div className={`pageLabel ${className || ''}`}>
            {icon && <div className="pageLabel__iconLeft">{icon}</div>}
            <span className="pageLabel__text">{text}</span>
        </div>
    );
}

export default PageLabel;